const request = (url, options) => fetch(url, options)
  .then((res) => {
    if (res.status > 399) {
      return res.text().then((text) => {
        throw new Error(`${res.statusText} Error: ${text}`)
      })
    } else {
      return res
    }
  })

export default request
